import React from "react";
import { motion } from "framer-motion";

const team = [
  {
    name: "Shaukat Ali",
    role: "CEO",
    desc: "CEO of ALLIED SOFTWARE ENGINEERS (PRIVATE) LIMITED.",
    photo: "shoukat ali.jpeg",
  },
  {
    name: "Muhammad Ahsan Ali",
    role: "CEO/Director",
    desc: "Senior full stack web developer",
    photo: "Ahsan.jpeg",
  },
  {
    name: "Abdul Wasay Sial",
    role: "Director / Senior Software Engineer",
    desc: "Technical leadership and full-stack integration.",
    photo: "wasy.jpeg",
  },
  {
    name: "Faseeh Anjum",
    role: "Senior Software Engineer",
    desc: "Scalability, cloud infrastructure, and DevOps.",
    photo: "Fasih.jpeg",
  },
  {
    name: "Talha Zain",
    role: "CFO",
    desc: "Chief Financial Officer",
    photo: "Talha.jpeg",
  },
  {
    name: "Umer Farooq",
    role: "Software Engineer",
    desc: "Core backend architecture and API design.",
    photo: "omer.jpeg",
  },
  {
    name: "Salman Fazal",
    role: "Software Engineer",
    desc: "Frontend systems and user experience.",
    photo: "Salman afzal.jpeg",
  },
  
];

export default function Team() {
  return (
    <main className="bg-slate-900 text-white min-h-screen pt-32 pb-20 selection:bg-aseBlue selection:text-white">
      <div className="max-w-7xl mx-auto px-4">
        
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-aseBlue font-semibold tracking-wider uppercase text-sm mb-4 block">Our People</span>
          <h1 className="text-5xl md:text-6xl font-display font-bold tracking-tight mb-6">
            Meet The <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500">Engineers.</span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            A dedicated team of visionaries, architects, and builders driving digital transformation.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {team.map((m, index) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="group relative bg-slate-800/50 border border-white/5 rounded-3xl overflow-hidden hover:border-aseBlue/30 transition-colors duration-500"
            >
              <div className="aspect-[4/5] w-full overflow-hidden relative">
                {/* Background gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent z-10 opacity-80 group-hover:opacity-60 transition-opacity duration-500"></div>
                
                <img
                  src={`/team/${m.photo}`}
                  alt={m.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
                />
                
                {/* Text Content overlaying image */}
                <div className="absolute bottom-0 left-0 w-full p-6 z-20 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="text-aseBlue text-xs font-bold uppercase tracking-wider mb-1 block">
                    {m.role}
                  </span>
                  <h2 className="text-2xl font-display font-semibold text-white mb-2">
                    {m.name}
                  </h2>
                  {m.desc && (
                    <p className="text-gray-400 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 line-clamp-2">
                      {m.desc}
                    </p>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </main>
  );
}